// Copyright 2018 Sorama B.V.

import { autoinject } from "aurelia-framework";
import { Region, Resolution } from "datatypes/SoramaLocalApi";
import { StreamMeasurementServiceError } from "errors/StreamMeasurementServiceError";
import { StringExtensions } from "extensions/StringExtensions";
import { ILocalApi } from "libraries/WebApi/ILocalApi";
import { IWebRequestHandler } from "libraries/WebRequestHandler/IWebRequestHandler";

@autoinject
export class VideoStreamPreviewService {
    private readonly webRequestHandler: IWebRequestHandler;
    private readonly localApi: ILocalApi;

    //#region API Calls
    private static apiPostFix = "Video";
    private static feedApiCall = "/" + VideoStreamPreviewService.apiPostFix + "/{0}/Feed";
    private static resolutionApiCall = "/" + VideoStreamPreviewService.apiPostFix + "/{0}/Resolution";
    private static visibleRegionApiCall =
        "/" + VideoStreamPreviewService.apiPostFix + "/{0}/VisibleRegion?distance={1}";

    //#endregion

    constructor(webRequestHandler: IWebRequestHandler, localApi: ILocalApi) {
        this.webRequestHandler = webRequestHandler;
        this.localApi = localApi;
    }

    //#region IVideoStreamPreviewService

    public getResolution(key: string): Promise<Resolution> {
        return this.localApi.stream.then((uri) => {
            return this.webRequestHandler
                .createGetRequest<Resolution>(
                    uri + StringExtensions.format(VideoStreamPreviewService.resolutionApiCall, key)
                )
                .send()
                .then((x) => x.content)
                .catch((error) => Promise.reject(new StreamMeasurementServiceError(error.message)));
        });
    }

    public previewImage(key: string): Promise<string> {
        return Promise.reject<string>(new Error("Not yet implemented"));
    }

    public getStreamAddress(key: string): Promise<string> {
        return this.localApi.stream.then((uri) => {
            return uri + StringExtensions.format(VideoStreamPreviewService.feedApiCall, key);
        });
    }

    public getVisibleRegion(distance: number, key: string): Promise<Region> {
        return this.localApi.stream.then((uri) => {
            return this.webRequestHandler
                .createGetRequest<Region>(
                    uri +
                        StringExtensions.format(
                            VideoStreamPreviewService.visibleRegionApiCall,
                            key,
                            distance.toString()
                        )
                )
                .send()
                .then((x) => x.content)
                .catch((error) => Promise.reject(new StreamMeasurementServiceError(error.message)));
        });
    }

    //#endregion
}
